import React, { Component } from 'react';
import { compose } from "react-apollo";
import pdfMake from 'pdfmake/build/pdfmake.js';
import pdfFonts from 'pdfmake/build/vfs_fonts.js';
import $ from 'jquery';
import { QueryGetAnalysis } from "../GraphQL/MutationAnalysis";
import { QueryGetAssessment } from "../GraphQL/MutationAssessment";
import { QueryGetTherapist } from "../GraphQL/MutationTherapist";
import * as Utils from '../Lib/Utils';
import Spinner from './Spinner';
import SVGRT from './SVGRT';
import SVGRB from './SVGRB';
import SVGLT from './SVGLT';
import SVGLB from './SVGLB';
import { client } from '../App';

import moment from "moment-timezone";

class AnalysisPDF extends Component {
	subHandApps = localStorage.getItem('subHandsApps');
	constructor(props) {
		super(props);

		this.state = {
			isOver24Hours: false,
			modalConfirmIsOpen: false,
			modalAddNoteIsOpen: false,
			loading: false,
			isEdit: false,
			maxUndo: 30,
			undoList: [],
			errors: {},
			isError: false,
			errorMessage: null,
			coloursLT: {},
			coloursLB: {},
			coloursRT: {},
			coloursRB: {},
			selectedColor: '#ffffff',
			colorDefault: "#ffffff",
			therapistName: null,
			therapistEmail: null,
			patientName: '',
			therapistName: '',
		};

		this.state = {...Utils.COLOR, ...this.getInitialState(), ...this.state};
		this.clearForm = this.clearForm.bind(this);
	}

	getInitialState = () => ({
		analysis: {
			assessmentId: this.props.match.params.assessment_id,
			analysisId: "",
			coloursLT: "",
			coloursLB: "",
			coloursRT: "",
			coloursRB: "",
			date: moment.tz('Australia/Sydney').format(),
			handSide: "",
			type: "SWMT",
			noteTitleLT: "",
			noteTitleLB: "",
			noteTitleRT: "",
			noteTitleRB: "",
			noteContentLT: "",
			noteContentLB: "",
			noteContentRT: "",
			noteContentRB: "",
			created: moment.utc().format(),
			updated: moment.utc().format()
		}
	});

	clearForm = () => {
		this.setState(this.getInitialState());
	}

	loadAnalysisColours(analysis) {
		if(analysis.coloursLT !== '') {
			let coloursLT = JSON.parse(analysis.coloursLT);
			this.setState({ coloursLT });
			this.fillColorToHand(coloursLT, '.SVGLT');
		}
		if(analysis.coloursLB !== '') {
			let coloursLB = JSON.parse(analysis.coloursLB);
			this.setState({ coloursLB });
			this.fillColorToHand(coloursLB, '.SVGLB');
		}
		if(analysis.coloursRT !== '') {
			let coloursRT = JSON.parse(analysis.coloursRT);
			this.setState({ coloursRT });
			this.fillColorToHand(coloursRT, '.SVGRT');
		}
		if(analysis.coloursRB !== '') {
			let coloursRB = JSON.parse(analysis.coloursRB);
			this.setState({ coloursRB });
			this.fillColorToHand(coloursRB, '.SVGRB');
		}
	}

	fillColorToHand(colours, element) {
		for (let key in colours) {
			let color = this.state.colorDefault;
			if(colours[key] !== undefined) {
				color = colours[key];
			}
			var prefix = key.substr(0, 1);
			$(element+' '+key).css('fill', color);
			if(prefix === '.') {
				var newKey = key.replace('.', '#');
				$(element+' '+newKey+'-1').css('fill', '#ffffff');
				$(element+' '+newKey+'-2').css('fill', '#ffffff');
				$(element+' '+newKey+'-3').css('fill', '#ffffff');
				$(element+' '+newKey+'-4').css('fill', '#ffffff');
			}
		}
	}

	loadData = async (e) => {
		this.setState({ loading: true });
		const { match: { params } } = this.props;

		if(params.id) {
			const { analysis } = this.state;
			this.state.isEdit = true;
			const result = await client.query({
				query: QueryGetAnalysis,
				fetchPolicy: 'network-only',
				variables: {
					assessmentId: params.assessment_id,
					analysisId: params.id
				},
			});

			var data = result.data.getAnalysis;
			if(data) {
				analysis['assessmentId'] = data.assessmentId;
				analysis['analysisId'] = data.analysisId;
				analysis['handSide'] = data.handSide;
				analysis['date'] = data.date;
				analysis['created'] = data.created;
				if(data.coloursLT)
					analysis['coloursLT'] = data.coloursLT;
				if(data.coloursLB)
					analysis['coloursLB'] = data.coloursLB;
				if(data.coloursRT)
					analysis['coloursRT'] = data.coloursRT;
				if(data.coloursRB)
					analysis['coloursRB'] = data.coloursRB;
				if(data.type)
					analysis['type'] = data.type;
				if(data.noteTitleLT)
					analysis['noteTitleLT'] = data.noteTitleLT;
				if(data.noteTitleLB)
					analysis['noteTitleLB'] = data.noteTitleLB;
				if(data.noteTitleRT)
					analysis['noteTitleRT'] = data.noteTitleRT;
				if(data.noteTitleRB)
					analysis['noteTitleRB'] = data.noteTitleRB;
				if(data.noteContentLT)
					analysis['noteContentLT'] = data.noteContentLT;
				if(data.noteContentLB)
					analysis['noteContentLB'] = data.noteContentLB;
				if(data.noteContentRT)
					analysis['noteContentRT'] = data.noteContentRT;
				if(data.noteContentRB)
					analysis['noteContentRB'] = data.noteContentRB;

				this.setState({ analysis });
				this.loadAnalysisColours(analysis);
				this.exportPDF();
			}
		}

		this.setState({ loading: false });
	}

	loadPDF = async (e) => {
		let { patientName, therapistName, therapistEmail } = this.state;

		this.setState({ loading: true });
		
		if(!patientName) {
			const patient = await client.query({
				query: QueryGetAssessment,
				fetchPolicy: 'network-only',
				variables: {
				  therapistId: this.subHandApps,
				  assessmentId: this.props.match.params.assessment_id
				},
			});
			var data = patient.data.getAssessment;
			if(data) {
				patientName = data.firstName + ' ' + data.lastName;
				this.setState({ patientName });
			}
		}

		var assessment_id = this.props.match.params.assessment_id;
		var analysis_id = this.props.match.params.id;
		if(!therapistName) {
			const therapist = await client.query({
				query: QueryGetTherapist,
				fetchPolicy: 'network-only',
				variables: { id: this.subHandApps },
			});
			var obj = therapist.data.getTherapist;
			if(obj) {
				therapistName = obj.firstName + ' ' + obj.lastName;
				therapistEmail = obj.email;
				this.setState({ therapistName, therapistEmail });
			}
		}

		var fileName = therapistEmail + '/' + assessment_id + '/' + 'assessment-' + analysis_id + '.pdf';
		var params = {
			name: fileName,
			type: 'GET'
		};
		var result = await Utils.apiGateway("service/upload-pdf", params, "POST");
		if(result) {
			if(result.status !== undefined && result.status === 'success') {
				window.location.href = result.data;
				this.setState({ loading: false });
				return true;
			}
		}

		this.setState({ loading: false });
		return false;
	}

	componentDidMount() {
		if(!localStorage.getItem("AuthHandsApps")) {
			this.props.history.push('/');
		}
		this.clearForm();
		var isExistPdf = this.loadPDF();
		if(!isExistPdf) {
			this.loadData();
		}
	}

	footerPDF(type) {
		var wColor = 50;
		var hColor = 10;
		var marginColor = [0,0,0,4];
		var bgImgPurple;
		var bgImgOrange;
		var bgImgRedLine;
		if(type === 'WEST') {
			bgImgPurple = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAIAAACRXR/mAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6QjU5RkMwOEJBNzcwMTFFOEJCNEZCMEY4QURFRUI0MDciIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6QjU5RkMwOENBNzcwMTFFOEJCNEZCMEY4QURFRUI0MDciPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpCNTlGQzA4OUE3NzAxMUU4QkI0RkIwRjhBREVFQjQwNyIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpCNTlGQzA4QUE3NzAxMUU4QkI0RkIwRjhBREVFQjQwNyIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PqT3dOAAAABASURBVHja7M4xAQAwCAAgXXsb2sYl8PeABORUxz0vTtLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLafAEGAOsmAsQAmmSTAAAAAElFTkSuQmCC";
			bgImgOrange = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAIAAACRXR/mAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6QkQ3MTE3QzJBNzcwMTFFOEFCRjlFREUyOUM5MjVCQjAiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6QkQ3MTE3QzNBNzcwMTFFOEFCRjlFREUyOUM5MjVCQjAiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpCRDcxMTdDMEE3NzAxMUU4QUJGOUVERTI5QzkyNUJCMCIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpCRDcxMTdDMUE3NzAxMUU4QUJGOUVERTI5QzkyNUJCMCIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PqyCV50AAAA/SURBVHja7M5BDQAwCASwY/5/CAYbI2kVtKbzoZdoaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpXWqtAAMAMN0B9slt+I8AAAAASUVORK5CYII=";
			bgImgRedLine = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAIAAACRXR/mAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6Qjk4MzYyMDdBNzcwMTFFOEI0NzhDMUY3RDA0RDhCNjMiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6Qjk4MzYyMDhBNzcwMTFFOEI0NzhDMUY3RDA0RDhCNjMiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpCOTgzNjIwNUE3NzAxMUU4QjQ3OEMxRjdEMDREOEI2MyIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpCOTgzNjIwNkE3NzAxMUU4QjQ3OEMxRjdEMDREOEI2MyIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Pj7763UAAAAiSURBVHja7MExAQAAAMKg9U9tCF+gAAAAAAAAAPhNAAEGAB1+AAHr9+viAAAAAElFTkSuQmCC";
		} else {
			bgImgPurple = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAIAAACRXR/mAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RTk5MThDODQ3QUI5MTFFODk0NDZENkRCOUQwMDkzQjgiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RTk5MThDODU3QUI5MTFFODk0NDZENkRCOUQwMDkzQjgiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpFOTkxOEM4MjdBQjkxMUU4OTQ0NkQ2REI5RDAwOTNCOCIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpFOTkxOEM4MzdBQjkxMUU4OTQ0NkQ2REI5RDAwOTNCOCIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Pos7tY4AAABBSURBVHja7M4xAQAwCAAgXRlLG8KIS+DvAQnIrol7XpykpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWltfkCDACdigHXzXCnYgAAAABJRU5ErkJggg==";
			bgImgOrange = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAIAAACRXR/mAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RkQwNEVGRDY3QUI5MTFFODg1MzlERkMwRkY5MEE2NDciIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RkQwNEVGRDc3QUI5MTFFODg1MzlERkMwRkY5MEE2NDciPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpGRDA0RUZENDdBQjkxMUU4ODUzOURGQzBGRjkwQTY0NyIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpGRDA0RUZENTdBQjkxMUU4ODUzOURGQzBGRjkwQTY0NyIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Plt91ioAAABASURBVHja7M4xDQAwCAAwmHYSZDMF/BytguZ0xT0vTtLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLafAEGAANLAm5IDF1QAAAAAElFTkSuQmCC";
			bgImgRedLine = "data:image/png;base64,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";
		}

		var sensationFooter = {
			columns: [
				{
					stack: [
						{

						},
						{
							image: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAIAAACRXR/mAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6REVEMjQzMTc3QUI5MTFFOEJCNkNBQTI5QjYwMzEwQ0UiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6REVEMjQzMTg3QUI5MTFFOEJCNkNBQTI5QjYwMzEwQ0UiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpERUQyNDMxNTdBQjkxMUU4QkI2Q0FBMjlCNjAzMTBDRSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpERUQyNDMxNjdBQjkxMUU4QkI2Q0FBMjlCNjAzMTBDRSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PpKbvngAAABBSURBVHja7M4xAQAwCAOwMv8G8IQoFOznSBSkMp17Xk7S0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS+lkBBgAALgHJzc+WgAAAAABJRU5ErkJggg==",
							width: wColor,
						    height: hColor,
							margin: [0,15,0,4]
						},
						{
							image: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAIAAACRXR/mAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RjJERURCQjM3QUI5MTFFOEI2ODVBRDU5MkFBMkU5NjAiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RjJERURCQjQ3QUI5MTFFOEI2ODVBRDU5MkFBMkU5NjAiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpGMkRFREJCMTdBQjkxMUU4QjY4NUFENTkyQUEyRTk2MCIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpGMkRFREJCMjdBQjkxMUU4QjY4NUFENTkyQUEyRTk2MCIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PgK7PUAAAABCSURBVHja7M4xDQAwCAAwQvYjF8+omAJ+jlZBX/XEPRknaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaW2+AAMAnMkB11PJYwIAAAAASUVORK5CYII=",
							width: wColor,
							height: hColor,
							margin: marginColor
						},
						{
							image: bgImgPurple,
							width: wColor,
							height: hColor,
							margin: marginColor
						},
						{
							image: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAIAAACRXR/mAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RDFGOTY2ODA3QUI5MTFFODhERDFGRkJEQjQ5QzlDMjIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RDFGOTY2ODE3QUI5MTFFODhERDFGRkJEQjQ5QzlDMjIiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpEMUY5NjY3RTdBQjkxMUU4OEREMUZGQkRCNDlDOUMyMiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpEMUY5NjY3RjdBQjkxMUU4OEREMUZGQkRCNDlDOUMyMiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PpJiucMAAABCSURBVHja7M4xAQAwCAAgXSgL2L+NAZbA3wMSkNMV97w4SUtLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS2vzBRgA7WUB0aN0JQ0AAAAASUVORK5CYII=",
							width: wColor,
							height: hColor,
							margin: marginColor
						},
						{
							image: bgImgOrange,
							width: wColor,
							height: hColor,
							margin: marginColor
						},
						{
							image: bgImgRedLine,
						  	width: wColor,
						  	height: hColor,
					    },
					],
					width: '15%',
				},
				{
					stack: [
						'TYPE',
						'GREEN',
						'BLUE',
						(type === 'WEST') ? 'PINK' : 'PURPLE',
						'RED',
						(type === 'WEST') ? 'ORANGE' : 'LIGHT RED',
						(type === 'WEST') ? 'BLACK' : 'RED LINED',
					],
					width: '20%',
				},
				{
					stack: [
						(type === 'WEST') ? 'WEST' : 'SWMT',//'WEINSTEIN ENHANCED SESORY TEST' : 'SEMMES WEINSTEIN MONOFILAMENT TEST',
						'NORMAL',
						'DIMINISHED LIGHT TOUCH',
						'DIMINISHED PROTECTIVE SENSATION',
						'LOSS OF PROTECTIVE SENSATION',
						'DEEP PRESSURE SENSATION ONLY',
						'UNRESPONSIVE TO',
					],
					width: '50%',
					alignment: 'left',
				},
				{
					stack: [
						(type === 'WEST') ? '     0.07gm' : '       2.83',
					    (type === 'WEST') ? '     0.2gm'  : '		3.61',
						(type === 'WEST') ? '     2.0gm'  : '		4.31',
						(type === 'WEST') ? '     4.0gm'  : '		4.56',
						(type === 'WEST') ? '     200gm'  : '       6.65',
						(type === 'WEST') ? '     200gm'  : '       6.65'
					],
					margin: [ 0, 12, 0, 0 ],
					width: '15%',
					alignment: 'right'
				},
			],
			margin: [ 10, 20, 10, 0 ],
		};
		return sensationFooter;
	}

	exportPDF = async (e) => {
		const { analysis: {
			assessmentId,
			date,
			type,
			coloursLT,
			coloursLB,
			coloursRT,
			coloursRB,
			noteTitleLT,
			noteTitleLB,
			noteTitleRT,
			noteTitleRB,
			noteContentLT,
			noteContentLB,
			noteContentRT,
			noteContentRB
		} } = this.state;
		let { patientName, therapistName, therapistEmail } = this.state;

		var assessment_id = this.props.match.params.assessment_id;
		var analysis_id = this.props.match.params.id;
		var fileName = therapistEmail + '/' + assessment_id + '/' + 'assessment-' + analysis_id + '.pdf';
		this.setState({ loading: true });

		var cLT = document.getElementById("handCanvasLT");
		var cLB = document.getElementById("handCanvasLB");
		var cRT = document.getElementById("handCanvasRT");
		var cRB = document.getElementById("handCanvasRB");
		window.canvg('handCanvasLT', $('#SVG-LT').html());
		window.canvg('handCanvasLB', $('#SVG-LB').html());
		window.canvg('handCanvasRT', $('#SVG-RT').html());
		window.canvg('handCanvasRB', $('#SVG-RB').html());

		var $this = this;
		var assessmentDate = moment(date).utcOffset (date).format('DD MMM YYYY HH:mm');
		setTimeout(function() {
			var listHands = [];
			if(coloursLT !== '{}') {
				listHands.push({
					handSide: 'LT',
					handText: 'Left Dorsal',
					colours: coloursLT,
					canvas: cLT,
					noteTitle: noteTitleLT,
					noteContent: noteContentLT
				});
			}

			if(coloursLB !== '{}') {
				listHands.push({
					handSide: 'LB',
					handText: 'Left Palmar',
					colours: coloursLB,
					canvas: cLB,
					noteTitle: noteTitleLB,
					noteContent: noteContentLB
				});
			}

		    if(coloursRT !== '{}') {
				listHands.push({
					handSide: 'RT',
					handText: 'Right Dorsal',
					colours: coloursRT,
					canvas: cRT,
					noteTitle: noteTitleRT,
					noteContent: noteContentRT
				});
			}

			if(coloursRB !== '{}') {
				listHands.push({
					handSide: 'RB',
					handText: 'Right Palmar',
					colours: coloursRB,
					canvas: cRB,
					noteTitle: noteTitleRB,
					noteContent: noteContentRB
				});
			}

			var handsContent = [];
			var notesContent = [];
			var index = 0;
			var indexNote = 0;
			listHands.map((item, i) => {
				handsContent[index++] = {
					columns: [
						{
							width: '25%',
							text: 'Therapist: ' + therapistName,
						},
						{
							width: '25%',
							text: 'Name: ' + patientName,
							alignment: 'center',
						},
						{
							width: '*',
							text: 'Hand: ' + item.handText,
							alignment: 'center',
						},
						{
							width: '30%',
							text: 'Date: ' + assessmentDate,
							alignment: 'right'
						},
					],
					margin: [ 5, 20, 5, 0 ],
				};

				var isHasNote = ((item.noteTitle && item.noteContent) && (item.noteTitle !== '' || item.noteContent !== '')) ? true : false;
				if(isHasNote) {
					notesContent[indexNote++] = {
						'header': item.handText,
						'title': item.noteTitle,
						'comments': item.noteContent
					};
				}

				handsContent[index] = {};
				handsContent[index]['image'] = item.canvas.toDataURL(),
				handsContent[index]['alignment'] = 'center';
				handsContent[index]['fit'] = [600, 600];

				handsContent[++index] = $this.footerPDF(type);
				if((i+1) < listHands.length) {
					handsContent[index++]['pageBreak'] = 'after';
				} else if(notesContent.length > 0) {
					handsContent[index++]['pageBreak'] = 'after';
				}
			});

			if(notesContent.length > 0) {
				notesContent.map((item, i) => {
					handsContent[index++] = {
						columns: [
							{
								stack: [
									item.header
								],
								style: {
									fontSize: 13,
									bold: true
								},
								width: '100%',
							}
						],
						margin: [ 10, 10, 0, 5 ]
					};

					handsContent[index++] = {
						columns: [
							{
								stack: [
									{text: 'Note Title', margin: [0,0,0,5]},
									'Comments',
								],
								style: {
									fontSize: 12,
									margin: [0, 15],
									bold: true
								},
								width: '15%',
							},
							{
								stack: [
									{text: item.title, margin: [0,0,0,5]},
									item.comments,
								],
								style: {
									margin: [0, 15],
								},
								width: '*',
							},
						],
						margin: [ 10, 0, 10, 25 ]
					};
				});
			}

			var docDefinition = {
				header: {
					columns: [
						{
							image: "data:image/png;base64,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",
							fit: [60,60],
							margin: [ 20, 10, 10, 5 ],
							width: '27%'
						},
						{
							width: '*',
							stack: [
								{
									text: 'SENSATION ASSESSMENT',
									margin: [ 10, 10, 30, 2 ],
									style: 'header',
								},
								{
									text: 'https://www.sensationax.com',
									margin: [ 48, 0, 30, 0 ],
									fontSize: 14
								}
							]
						}
					]
				},
				content: handsContent,
				styles: {
 					header: {
						fontSize: 22,
				        bold: true,
						alignment: 'left'
				     },
				     anotherStyle: {
						 fontSize: 15
				     }
			 	},
				pageMargins: [ 20, 55, 20, 20 ],
			};

			pdfMake.vfs = pdfFonts.pdfMake.vfs;
			const pdfDocGenerator = pdfMake.createPdf(docDefinition);
			pdfDocGenerator.getBase64((data) => {
				var params = {
					data: data,
					name: fileName,
					type: 'POST'
				};
				var result = Utils.apiGateway("service/upload-pdf", params, "POST");
				result.then(res => {
					window.location.href = result.data;
					$this.setState({ loading: false });
				}).catch(err => {
					$this.setState({ loading: false });
				});
			});
		}, 1500);
	}


	render() {
		const { loading } = this.state;
		return (
			<section role="main">
				<canvas id="handCanvasLT" width="524px" height="842px" style={{display: 'none'}} />
				<canvas id="handCanvasLB" width="524px" height="842px" style={{display: 'none'}} />
				<canvas id="handCanvasRT" width="524px" height="842px" style={{display: 'none'}} />
				<canvas id="handCanvasRB" width="524px" height="842px" style={{display: 'none'}} />
				<div className={`${(this.props.loading || loading) ? ' loading-overlay-showing' : ''}`}>
					<Spinner />
					<div className="col-xs-12 col-md-9 hand-svg-box">
						<div data-label="pointer">
							<span id="SVG-RB"><SVGRB className={`SVGRB`} /></span>
							<span id="SVG-RT"><SVGRT className={`SVGRT`} /></span>
							<span id="SVG-LT"><SVGLT className={`SVGLT`} /></span>
							<span id="SVG-LB"><SVGLB className={`SVGLB`} /></span>
						</div>
					</div>
				</div>
			</section>
		)
	}
}

export default AnalysisPDF;
